import { createAsyncThunk, current } from '@reduxjs/toolkit';
import axios from 'axios';
import { axiosCustom } from '../../../utils/axiosUser';

export const initStateGameUserAdd = {
  gameUserAdd: { data: null, loading: false, error: null },
};

export const gameUserAdd = createAsyncThunk('user/gameUserAdd', async (data, { rejectWithValue, fulfillWithValue }) => {
  return await axiosCustom
    .post(`/game/user/add`, data)
    .then((res) => {
      return fulfillWithValue(res.data);
    })
    .catch((res) => {
      return rejectWithValue(res.response.data);
    });
});

export const reducerGameUserAdd = {
  [gameUserAdd.pending]: (state) => {
    state.gameUserAdd.loading = true;
  },
  [gameUserAdd.fulfilled]: (state, action) => {
    state.gameUserAdd.loading = false;
    state.gameUserAdd.data = action.payload;
    state.gameUserAdd.error = null;
  },
  [gameUserAdd.rejected]: (state, action) => {
    state.gameUserAdd.loading = false;
    state.gameUserAdd.error = action.payload;
  },
};
